import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import Button from "@mui/material/Button";
import formatDate from "../.././util/dateFormat";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { useAppSelector } from "../../redux/hooks";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { getEncodedLastkey, getEncodedValue } from "../forms/utility";
import { getVouchers } from "../../services/ApiServices/vouchers";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  hashValue,
  DateConstants,
  modelName,
} from "../../constants/AppConstants";
import { exportData } from "../../services/ApiServices/export";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
const listOfStatus = [
  {
    name: filterConstants.Utilized,
    value: true,
  },
  { name: filterConstants.Unutilized, value: false },
];
interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}

const AdminVoucherTransaction = () => {
  const { getUserPermission: getVoucherTransactionPermission } =
    usePermissionGetter("voucher_transactions", "voucher_transactions");
  const buttonStyles = useButtonStyles();
  // const [listOfSourece, setListOfSourceVoucher] = useState<any>([]);
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const [open, setOpen] = useState(false);

  const [sending, setSending] = useState(false);
  const [data, setData] = useState([]);
  const [isApiCall, setIsApiCall] = useState(true);
  const [nextPagekey, setNextPageKey] = useState<any>(null);
  const [emailSent, setEmailSent] = useState(false);
  const [apiFromKey, setAPIFromKey] = useState<Number>(0);
  const [totalDataCount, setTotalDataCount] = useState<Number>(0);
  const [filterActive, setFilterActive] = useState(false);
  const [dateFilter, setDateFilter] = useState({
    fromDate: "",
    toDate: "",
    filterKey: "",
  });
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();

  const columns: TableColumn[] = [
    {
      key: "loyaltyCardNumber",
      header: "Loyalty Card Number",
    },
    {
      key: "voucherSerialNumber",
      header: "Serial Number",
    },
    { key: "voucherTitle", header: "Title" },
    { key: "issueOn", header: "Issuance Date" },
    { key: "orderId", header: "Order ID" },
    { key: "amount", header: "Reward Value" },
    { key: "voucherExpiryDate", header: "Expiry Date" },
    { key: "sourceOfVoucher", header: "Source of Voucher" },
    { key: "voucherUtilisedDate", header: "Utilization Date" },
    { key: "merchantName", header: "Merchant Name" },
    { key: "transactionCode", header: "Transaction ID" },
    { key: "voucherStatus", header: "Status" },
  ];

  const listOfSourceVouchers = [
    "Auto_Evoucher",
    "Auto_Merchant",
    "Rewards_Evoucher_Single",
    "Rewards_Merchant",
    "Rewards_CarPark",
    "Promo_Carpark",
    "MR_Evoucher",
    "Promo_Evoucher",
    "Yuu_Evoucher",
    "Promo_LoyaltyPoints",
    "CSP_Coupons",
    "FS_Merchant",
  ];

  const formatToLocalTime = (inputDatetime: string) => {
    inputDatetime.replace(" ", "T");
    inputDatetime = inputDatetime + "+08:00";
    return inputDatetime;
  };
  const getVoucherTransaction = async (url: string, canMergeData?: boolean) => {
    let currentURl = url;
    try {
      setLoadingAPI(true);
      const voucherResponse = await getVouchers(currentURl);
      const { fromKey, lastKey, result, totalCount } =
        voucherResponse?.result?.data;
      const lastDataKey = lastKey ? lastKey : null;
      setNextPageKey(lastDataKey);
      setTotalDataCount(totalCount);
      setAPIFromKey(fromKey);
      const resultData = result.map((item: any) => item._source);

      const mappedData = resultData.map((voucher: any) => ({
        merchantName: voucher?.merchantName ? voucher?.merchantName : "-",
        loyaltyCardNumber: voucher.loyaltyNo ? voucher.loyaltyNo : "-",
        voucherTitle: voucher.title ? voucher.title : "-",
        voucherSerialNumber: voucher.couponCode ? voucher.couponCode : "-",
        transactionCode: voucher.transaction_id ? voucher.transaction_id : "-",
        amount: voucher.amount ? voucher.amount : "-",
        issueOn:
          voucher.hasOwnProperty("createdDate") && voucher.createdDate
            ? formatDate(voucher.createdDate)
            : voucher?.redeemedDate
              ? formatDate(voucher?.redeemedDate)
              : "-",
        voucherUtilisedDate: voucher.utilizedDate
          ? formatDate(voucher.utilizedDate)
          : "-",
        voucherExpiryDate: voucher.expiryDate
          ? formatDate(voucher.expiryDate)
          : "-",
        voucherStatus: voucher.utilized ? "Utilized" : "Unutilized",
        sourceOfVoucher: voucher.purpose ? voucher.purpose : "-",
        orderId: voucher.order_id ? voucher.order_id : "-",
      }));
      const dataToMap = canMergeData ? [...data, ...mappedData] : mappedData;
      setData(dataToMap);

      // if (!listOfSourece.length) {
      //   const uniqueSources = Array.from(
      //     new Set(result.map((voucher: any) => voucher._source.purpose))
      //   );
      //   setListOfSourceVoucher(uniqueSources);
      // }
    } catch (error) {
      console.error(error);
      setLoadingAPI(false);
    } finally {
      setLoadingAPI(false);
      setIsApiCall(false);
    }
  };
  useEffect(() => {
    if (isApiCall) bindSearchAndFilter();
    // getVoucherTransaction();
  }, [isApiCall]);

  const handleExport = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  // filter and search UI
  const merchantList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.merchantList,
  );
  const lab = merchantList.reduce((sub: any, item: any) => {
    if (!sub.includes(item.username)) {
      sub.push(item.username);
    }
    return sub;
  }, []);
  const [openFilter, setOpenFilter] = useState(false);

  const [filterState, setFilterState] = useState({
    issuanceDate: "",
    expiryDate: "",
    amountFrom: "",
    amountTo: "",
    sourceOfVoucher: "",
    status: "",
    merchant: "",
  });

  const resetFilterState = () => {
    setFilterState({
      issuanceDate: "",
      expiryDate: "",
      amountFrom: "",
      amountTo: "",
      sourceOfVoucher: "",
      status: "",
      merchant: "",
    });
    setFilterStates([]);
    handleSearch();
    setFilterActive(false);
  };

  const [filterStates, setFilterStates] = useState<any[]>([]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue,
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj,
        ),
      );
    }
  };

  const HandleMerchantChange = (event: SelectChangeEvent) => {
    getAllFields(
      "merchantName",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal,
    );
    setFilterState((prev) => ({
      ...prev,
      merchant: event.target.value,
    }));
  };
  const HandleStatusChange = (event: SelectChangeEvent) => {
    getAllFields(
      "utilized",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal,
    );
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };

  const rewardValue = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    getAllFields(
      "amount",
      `${filterState.amountFrom},${event.target.value}`,
      operatorConstants.between,
    );

    setFilterState((prev) => ({
      ...prev,
      amountTo: (event.target as HTMLInputElement).value,
    }));
  };

  const applyVoucherTransactionFilter = () => {
    setOpenFilter(false);
    handleSearch();
  };
  const handleSourceOfVoucher = (event: SelectChangeEvent) => {
    getAllFields(
      "purpose",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal,
    );
    setFilterState((prev) => ({
      ...prev,
      sourceOfVoucher: event.target.value,
    }));
  };
  // search integration
  const searchInputRef = useRef<HTMLInputElement>();
  const handleSearch = () => {
    setData([]);
    setNextPageKey(null);
    setAPIFromKey(0);
    setTotalDataCount(0);
    setIsApiCall(true);
  };

  const bindSearchAndFilter = (canMergeData?: boolean) => {
    let qurryURl = getFilterParams();
    const searchParams = new URLSearchParams(qurryURl);
    const filtersValue = searchParams.get("filters");
    filtersValue && setFilterActive(true);
    let url = `fromKey=${apiFromKey}`;
    if (qurryURl) url += `&${qurryURl}`;
    if (nextPagekey) url += `&${getEncodedLastkey(nextPagekey)}`;
    getVoucherTransaction(url, canMergeData);
  };
  const getFilterParams = () => {
    const hashValue = {
      field: "campaignType",
      value: "event",
    };
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      hashData: hashValue,
      searchData: searchParam,
      filterData: filterStates,
    };
    const url = getHashURL(params);
    return url;
  };

  const adminEmail = useAppSelector(
    (state: any) => state.persistReducers.login.email,
  );
  const handleSendExport = async () => {
    const getFilterURL = getFilterParams();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.utilizedVouchers,
      hashKey.campaignType,
      hashValue.event,
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };
  return (
    <Grid
      borderRadius={"16px"}
      sx={{ background: theme.color?.background }}
      p={4}
      px={2}
    >
      <Grid>
        <ExportDialog
          closeDialog={setOpen}
          emailSent={emailSent}
          exportTitle="Voucher"
          handleClose={handleClose}
          open={open}
          sending={sending}
          handleSendExport={handleSendExport}
        />
        <Grid
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          px={3}
        >
          <Grid mt={3} alignItems={"left"} pl={4} pr={10} direction={"row"}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: theme?.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.thicker,
                fontSize: theme.font?.fontSize.large,
              }}
            >
              Voucher Transactions
            </Typography>
          </Grid>
          <Grid display={"flex"}>
            <Grid
              display={"flex"}
              alignItems={"center"}
              direction={"row"}
              pr={1}
            >
              {getVoucherTransactionPermission("export") && (
                <CommonButton
                  buttonTitle="Export"
                  variant="text"
                  color="secondary"
                  onClick={handleExport}
                  disabled={!data.length}
                />
              )}
            </Grid>
            <Grid
              display={"flex"}
              justifyContent={"center"}
              px={0}
              py={3}
              direction={"row"}
            >
              {getVoucherTransactionPermission("read") && (
                <Grid display={"flex"} gap={3}>
                  <SearchInput
                    HelpTip={SearchToolTip.Voucher}
                    onCallBack={handleSearch}
                    ref={searchInputRef}
                  />
                  <Button
                    variant="text"
                    startIcon={
                      filterActive ? (
                        <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                      ) : (
                        <FilterAltOutlinedIcon />
                      )
                    }
                    sx={{
                      color: theme.color?.newFilterGrey,
                      textTransform: "capitalize",
                    }}
                    onClick={() => {
                      setOpenFilter(true);
                    }}
                  >
                    Filter
                  </Button>
                </Grid>
              )}
            </Grid>
            <Dialog
              onClose={handleCloseFilter}
              open={openFilter}
              sx={{ ml: "60vw" }}
            >
              <Grid sx={{ width: "484px", py: 4, px: 2 }}>
                <DialogTitle
                  display={"flex"}
                  justifyContent={"space-between"}
                  borderBottom={theme.border?.smallGrey}
                >
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      color: theme.color?.primary,
                      fontSize: theme.font?.fontSize.large,
                      fontWeight: theme.font?.fontWeight.thicker,
                    }}
                  >
                    Filter
                  </Typography>
                  {/* <IconButton onClick={() => setOpenFilter(false)}> */}
                  <IconButton
                    onClick={() => {
                      setOpenFilter(false);
                    }}
                  >
                    <CloseOutlinedIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
                  <Grid>
                    <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.medium,
                          fontWeight: theme.font?.fontWeight.thick,
                        }}
                      >
                        Issuance Date
                      </Typography>
                      <Grid display={"flex"} gap={2} mt={2}>
                        <TextField
                          sx={{
                            display: "flex",
                            width: "80%",
                          }}
                          type="date"
                          size="small"
                          placeholder="Issuance Date"
                          value={filterState.issuanceDate}
                          onChange={(e) => {
                            getAllFields(
                              "createdDate",
                              new Date(e.target.value).getTime(),
                              operatorConstants.equal,
                            );
                            setFilterState((prev) => ({
                              ...prev,
                              issuanceDate: e.target.value,
                            }));
                          }}
                          InputProps={{
                            inputProps: {
                              max: DateConstants.maxDate,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.medium,
                          fontWeight: theme.font?.fontWeight.thick,
                        }}
                      >
                        Expiry Date
                      </Typography>
                      <Grid display={"flex"} gap={2} mt={2}>
                        <TextField
                          sx={{
                            display: "flex",
                            width: "80%",
                          }}
                          type="date"
                          size="small"
                          placeholder="Transaction Date"
                          value={filterState.expiryDate}
                          onChange={(e) => {
                            getAllFields(
                              "expiryDate",
                              new Date(e.target.value).getTime(),
                              operatorConstants.equal,
                            );
                            setFilterState((prev) => ({
                              ...prev,
                              expiryDate: e.target.value,
                            }));
                          }}
                          InputProps={{
                            inputProps: {
                              max: DateConstants.maxDate,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.medium,
                          fontWeight: theme.font?.fontWeight.thick,
                        }}
                      >
                        Reward Value ($)
                      </Typography>
                      <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                        <TextField
                          sx={{
                            display: "flex",
                            width: "38%",
                          }}
                          type="text"
                          size="small"
                          label="from"
                          value={filterState.amountFrom}
                          onChange={(e) =>
                            setFilterState((prev) => ({
                              ...prev,
                              amountFrom: e.target.value,
                            }))
                          }
                        />
                        <TextField
                          sx={{
                            display: "flex",
                            width: "38%",
                          }}
                          type="text"
                          size="small"
                          label="To"
                          value={filterState.amountTo}
                          onChange={(e) => rewardValue(e)}
                        />
                      </Grid>
                    </Grid>
                    <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.medium,
                          fontWeight: theme.font?.fontWeight.thick,
                        }}
                      >
                        Source of Voucher
                      </Typography>
                      <Grid
                        gap={2}
                        mt={2}
                        display={"flex"}
                        sx={{
                          width: "80%",
                        }}
                      >
                        <FormControl
                          fullWidth
                          size="small"
                          sx={{
                            with: "100%",
                          }}
                        >
                          <Select
                            id=""
                            value={filterState.sourceOfVoucher}
                            onChange={handleSourceOfVoucher}
                          >
                            {listOfSourceVouchers.map((name: any) => (
                              <MenuItem value={name}>{name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.medium,
                          fontWeight: theme.font?.fontWeight.thick,
                        }}
                      >
                        Merchant
                      </Typography>
                      <Grid
                        gap={2}
                        mt={2}
                        display={"flex"}
                        sx={{
                          width: "80%",
                        }}
                      >
                        <FormControl
                          fullWidth
                          size="small"
                          sx={{
                            with: "100%",
                          }}
                        >
                          <Select
                            id=""
                            value={filterState.merchant}
                            onChange={HandleMerchantChange}
                          >
                            {lab.map((name: any) => (
                              <MenuItem value={name}>{name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                      <Typography
                        sx={{
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.medium,
                          fontWeight: theme.font?.fontWeight.thick,
                        }}
                      >
                        Status
                      </Typography>
                      <Grid
                        gap={2}
                        mt={2}
                        display={"flex"}
                        sx={{
                          width: "80%",
                        }}
                      >
                        <FormControl
                          fullWidth
                          size="small"
                          sx={{
                            with: "100%",
                          }}
                        >
                          <Select
                            id=""
                            value={filterState.status}
                            onChange={HandleStatusChange}
                          >
                            {listOfStatus.map((status: any) => (
                              <MenuItem value={status.value}>
                                {status.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
                  <Button
                    sx={{ ...buttonStyles.outlinedSecondary }}
                    onClick={resetFilterState}
                  >
                    Reset
                  </Button>
                  <Button
                    sx={{ ...buttonStyles.containedSecondary }}
                    onClick={applyVoucherTransactionFilter}
                  >
                    Apply
                  </Button>
                </DialogActions>
              </Grid>
            </Dialog>
          </Grid>
        </Grid>

        {getVoucherTransactionPermission("read") && (
          <Grid container width={"100%"} px={2} mt={2}>
            <InfiniteTable
              header={columns}
              contentItems={data}
              hasMoreRecords={nextPagekey !== null}
              fetchMoreData={() => bindSearchAndFilter(true)}
              isInitialLoading={data.length === 0 && loadingAPI}
              totalRecords={totalDataCount}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default AdminVoucherTransaction;
